export class PoolDto {
  mandatorySignIn: boolean;
  region: string;
  userPoolId: string;
  userPoolWebClientId: string;
  identityPoolId: string;
}
